/**
 * Static Data Selectors
 */

import { maxBy, minBy } from 'lodash';
import { createSelector } from 'reselect';

interface IPropsWithTempoFilter {
  tempoFilter: GQL.IIntegerRangeFilter | undefined;
}

export const getBusinessInformation = ({ staticData: { businessInformation } }: IStoreState) =>
  (businessInformation as GQL.IBusinessInformation);

export const getTempos = ({ staticData: { tempos } }: IStoreState) => tempos;
export const getTempoFilter = (_, { tempoFilter }: IPropsWithTempoFilter) => tempoFilter;
export const getExchangeRates = ({ staticData: { exchangeRates } }: IStoreState) => exchangeRates;
export const getLicenseComponents = ({ staticData: { licenseComponents } }: IStoreState) =>
  licenseComponents as GQL.ILicenseComponents;

export const getDefaultTempoValues = createSelector<IStoreState, GQL.ITempo[], GQL.IIntegerRangeFilter>(
  getTempos,
  (tempos) => ({
    // We apply a minus 1 to default values to convert to base zero
    // (Base zero is required by the Range Component)
    minimum: minBy(tempos, 'value')!.value! - 1,
    maximum: maxBy(tempos, 'value')!.value! - 1,
  }),
);

// tslint:disable-next-line:max-line-length
export const getDefaultTempoFilter = createSelector<IStoreState, IPropsWithTempoFilter, GQL.IIntegerRangeFilter, GQL.IIntegerRangeFilter | undefined, GQL.IIntegerRangeFilter>(
  [getDefaultTempoValues, getTempoFilter],
  (defaultValues, filter) => {
    return !!filter ? {
        minimum: filter.minimum ? (filter.minimum) - 1 : 0,
        maximum: filter.maximum ? (filter.maximum) - 1 : 0,
      }
      : defaultValues;
  },
);

export const getCurrencyOptions = createSelector(
  getExchangeRates,
  (rates) => {
    return [{
      value: 'CAD' as AcceptedCurrency,
      label: 'CAD',
    }].concat(rates.map(({ to_currency }) => ({
      value: to_currency as AcceptedCurrency,
      label: to_currency,
    })));
  },
);

export const getBusinessOpeningHours = createSelector(
  getBusinessInformation,
  (info) => info.opening_hours!,
);

export const getBusinessMainPhoneNumber = createSelector(
  getBusinessInformation,
  (info) => info.phone_numbers!.find((phone) => phone.type === 'main')!,
);

export const getBusinessEuropeanPhoneNumber = createSelector(
  getBusinessInformation,
  (info) => info.phone_numbers!.find((phone) => phone.type === 'europe')!,
);

export const getBusinessMainEmailAddress = createSelector(
  getBusinessInformation,
  (info) => info.emails!.find((email) => email.type === 'main')!,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/selectors/staticData.ts